import { SettingsPanelRoot } from "./SettingsPanel";
import {
    SettingsPanelAction,
    SettingsPanelEmpty,
    SettingsPanelRow,
    SettingsPanelSection,
    SettingsPanelSeparator,
    SettingsPanelToggleRow,
} from "./SettingsPanelParts";

export type { SettingsPanelRootProps } from "./SettingsPanel";
export type {
    SettingsPanelActionProps,
    SettingsPanelRowProps,
    SettingsPanelSectionProps,
    SettingsPanelToggleRowProps,
} from "./SettingsPanelParts";

/**
 * Settings popover with the Menu and Picker look, for panels whose rows hold
 * controls (pickers, switches, segmented controls, drag handles). `Root`
 * opens from its `trigger`; every other key is a part placed inside it, or
 * in its `footer` for `Action`.
 */
export const SettingsPanel = {
    Root: SettingsPanelRoot,
    Section: SettingsPanelSection,
    Separator: SettingsPanelSeparator,
    Row: SettingsPanelRow,
    ToggleRow: SettingsPanelToggleRow,
    Empty: SettingsPanelEmpty,
    Action: SettingsPanelAction,
};
